import React from 'react';

function ImpressumPage() {
  return (
    <div className="container mx-auto px-4 lg:px-12 py-8 max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 uppercase">
        Impressum
      </h1>

      <div className="prose prose-gray max-w-none space-y-8">
        {/* Angaben gemäß § 5 TMG */}
        <section>
          <h2 className="text-xl font-bold mb-4">Angaben gemäß § 5 TMG</h2>
          <p className="text-gray-700">
            ED STEEL<br />
            Inhaber: Erkan Deniz<br />
            Einzelunternehmen
          </p>
          <p className="text-gray-700 mt-4">
            <strong>Hinweis:</strong> Dieses Angebot richtet sich ausschließlich an Gewerbetreibende (B2B).
          </p>
        </section>

        {/* Kontakt */}
        <section>
          <h2 className="text-xl font-bold mb-4">Kontakt</h2>
          <p className="text-gray-700">
            Telefon: +49 171 629 5816<br />
            E-Mail: ed-steel@outlook.de
          </p>
        </section>

        {/* Umsatzsteuer */}
        <section>
          <h2 className="text-xl font-bold mb-4">Umsatzsteuer-ID</h2>
          <p className="text-gray-700">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
            Wird nach Erteilung nachgetragen.
          </p>
          <p className="text-gray-700 mt-2 text-sm italic">
            (Kleinunternehmerregelung nach § 19 UStG möglich – in diesem Fall wird keine Umsatzsteuer ausgewiesen.)
          </p>
        </section>

        {/* Verantwortlich für den Inhalt */}
        <section>
          <h2 className="text-xl font-bold mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p className="text-gray-700">
            Erkan Deniz<br />
            E-Mail: ed-steel@outlook.de
          </p>
        </section>

        {/* Streitschlichtung */}
        <section>
          <h2 className="text-xl font-bold mb-4">Streitschlichtung</h2>
          <p className="text-gray-700">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a 
              href="https://ec.europa.eu/consumers/odr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p className="text-gray-700 mt-2">
            <strong>Hinweis:</strong> Da unser Angebot ausschließlich an Unternehmer (B2B) gerichtet ist, 
            sind wir weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        {/* Haftung für Inhalte */}
        <section>
          <h2 className="text-xl font-bold mb-4">Haftung für Inhalte</h2>
          <p className="text-gray-700">
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten 
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
            Tätigkeit hinweisen.
          </p>
          <p className="text-gray-700 mt-2">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
            erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </section>

        {/* Haftung für Links */}
        <section>
          <h2 className="text-xl font-bold mb-4">Haftung für Links</h2>
          <p className="text-gray-700">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
            der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung 
            nicht erkennbar.
          </p>
          <p className="text-gray-700 mt-2">
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
            Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
            Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>
        </section>

        {/* Urheberrecht */}
        <section>
          <h2 className="text-xl font-bold mb-4">Urheberrecht</h2>
          <p className="text-gray-700">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
            der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen 
            Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
            nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p className="text-gray-700 mt-2">
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
            Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
            gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
            bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
            werden wir derartige Inhalte umgehend entfernen.
          </p>
        </section>

        {/* Stand */}
        <section className="pt-4 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            Stand: Februar 2026
          </p>
        </section>
      </div>
    </div>
  );
}

export default ImpressumPage;
